import CheckYourEmail from './CheckYourEmail.png';
import CheckYourTexts from './CheckYourTexts.png';
import KeyDrop247 from './KeyDrop-247.png';
import KeyDropCube from './KeyDrop-cube.png';
import KeyDropHybrid from './KeyDrop-vsa-hybrid.png';
import KeyDropVSA2 from './KeyDrop-vsa-2.0.png';
import KeyPickUp247 from './KeyPickUp-247.png';
import KeyPickUpCube from './KeyPickUp-cube.png';
import LicenseScan247 from './LicenseScan-247.png';
import LicenseScanCube from './LicenseScan-cube.png';
import LicenseScanVSA from './LicenseScan-vsa.png';
import LicenseScanHybrid from './LicenseScan-vsa-hybrid.png';
import LicenseScanExpress from './Express-License_Scan.png';
import PaymentPop247 from './PaymentPop-247.png';
import PaymentPopCube from './PaymentPop-cube.png';
import QRCodeScan247 from './QRCodeScan-247.png';
import QRCodeScanCube from './QRCodeScan-cube.png';
import QRCodeScanVSA from './QRCodeScan-vsa.png';
import QRCodeScanHybrid from './QRCodeScan-vsa-hybrid.png';
import ScanBarCode from './ScanBarCode.png';
import ScanQRCode from './ScanQRCode.png';
import ExpressKeyDropAndPickUp from './Express-Key_Drop_and_Pick-Up.png';
import ExpressPhoneQr from './Express-Phone_QR.png';
import ExpressQrScan from './Express-QR_Scan.png';
import HandKey from './HandKey.png';
import Arrow from './Arrow.png';

export const kiosk = {
    CheckYourEmail,
    CheckYourTexts,
    KeyDrop247,
    KeyDropCube,
    KeyDropHybrid,
    KeyDropVSA2,
    KeyPickUp247,
    KeyPickUpCube,
    LicenseScan247,
    LicenseScanCube,
    LicenseScanVSA,
    LicenseScanHybrid,
    LicenseScanExpress,
    PaymentPop247,
    PaymentPopCube,
    QRCodeScan247,
    QRCodeScanCube,
    QRCodeScanVSA,
    QRCodeScanHybrid,
    ScanBarCode,
    ScanQRCode,
    ExpressKeyDropAndPickUp,
    ExpressPhoneQr,
    ExpressQrScan,
    HandKey,
    Arrow,
};
